export const EMAIL_PH = "이메일을 입력해주세요.";
export const PASSWORD_PH = "비밀번호를 입력해주세요.";
export const CURRENT_PASSWORD_PH = "현재 비밀번호를 입력해주세요.";
export const NEW_PASSWORD_PH = "새로운 비밀번호를 입력해주세요.";
export const CONFIRM_PASSWORD_PH = "비밀번호를 다시 한 번 입력해주세요.";
export const NAME_PH = "이름을 입력해주세요.";
export const BIRTH_PH = "생년월일 8자리를 입력해주세요.";
export const PHONE_PH = "핸드폰 번호를 입력해주세요.";
export const VERIFICATION_CODE_PH = "인증코드를 입력해주세요.";
export const SHORT_FORM_VIDEO_LINK_PH = "출품 영상 링크를 입력해주세요.";
export const SHORT_FORM_ACCOUNT_PH = "회원가입 아이디 입력";
